import { createContext, useContext, useMemo } from "react";
const NonceContext = createContext("");
export const NonceProvider = props => {
  const { nonce, children } = props;
  const value = useMemo(() => ({ nonce }), [nonce]);
  return <NonceContext.Provider value={value}>{children}</NonceContext.Provider>;
};
export const useNonce = () => useContext(NonceContext);
